import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
const Navbar = () => {
  const [user, setUser] = useState(
    localStorage.getItem("compiauthtoken")
      ? jwtDecode(localStorage.getItem("compiauthtoken")).user
      : null
  );
  const navigate = useNavigate();
  const onLogoutClick = () => {
    localStorage.clear();
    window.location.reload();
    navigate("/");
    window.location.reload();
  };
  useEffect(() => {
    if (localStorage.getItem("compiauthtoken")) {
      setUser(jwtDecode(localStorage.getItem("compiauthtoken")).user);
    }
  }, []);
  return (
    <>
      <nav className="navbar navbar-expand-lg bg-body-tertiar">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            Mood Indigo - Competitions Portal
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              {user ? (
                user.username !== "pronites" ? (
                  <>
                    <li className="nav-item mx-3">
                      <NavLink
                        className="btn btn-outline-primary"
                        aria-current="page"
                        to="/judge/multicity"
                      >
                        Judge Scoring
                      </NavLink>
                    </li>
                    {user ? (
                      user.isSuperUser ? (
                        <li className="nav-item mx-3">
                          <NavLink
                            className="btn btn-outline-primary"
                            to="/admin/competitions"
                          >
                            Admin Home
                          </NavLink>
                        </li>
                      ) : (
                        <></>
                      )
                    ) : (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/competitions"
                        >
                          Admin Home
                        </NavLink>
                      </li>
                    )}
                    <li className="nav-item mx-3">
                      <NavLink
                        className="btn btn-outline-primary"
                        to="/admin/multicity"
                      >
                        Multicity Home
                      </NavLink>
                    </li>

                    {user ? (
                      user.isAdminCooride ? (
                        <li className="nav-item mx-3">
                          <NavLink
                            className="btn btn-outline-primary"
                            to="/admin/multicity/parameters"
                          >
                            Parameter Setting
                          </NavLink>
                        </li>
                      ) : user.isSuperUser ? (
                        <li className="nav-item mx-3">
                          <NavLink
                            className="btn btn-outline-primary"
                            to="/admin/multicity/parameters"
                          >
                            Parameter Setting
                          </NavLink>
                        </li>
                      ) : (
                        <></>
                      )
                    ) : (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/multicity/parameters"
                        >
                          Parameter Setting
                        </NavLink>
                      </li>
                    )}

                    {/* ADMIN COORDIE AND ABOVE */}
                    {user ? (
                      user.isSuperUser ? (
                        <li className="nav-item mx-3">
                          <NavLink
                            className="btn btn-outline-primary"
                            to="/admin/addcompi"
                          >
                            Add Competition
                          </NavLink>
                        </li>
                      ) : user.isAdminCooride ? (
                        <li className="nav-item mx-3">
                          <NavLink
                            className="btn btn-outline-primary"
                            to="/admin/addcompi"
                          >
                            Add Competition
                          </NavLink>
                        </li>
                      ) : (
                        <></>
                      )
                    ) : (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/addcompi"
                        >
                          Add Competition
                        </NavLink>
                      </li>
                    )}

                    {/* ONLY CGS */}
                    {user ? (
                      user.isSuperUser ? (
                        <li className="nav-item mx-3">
                          <NavLink
                            className="btn btn-outline-primary"
                            to="/admin/multicity/addcompi"
                          >
                            Add Mul Compi
                          </NavLink>
                        </li>
                      ) : (
                        <></>
                      )
                    ) : (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/multicity/addcompi"
                        >
                          Add Mul Compi
                        </NavLink>
                      </li>
                    )}

                    {user ? (
                      user.isCoordie ? (
                        <li className="nav-item mx-3">
                          <NavLink
                            className="btn btn-outline-primary"
                            to="/admin/multicity/judges"
                          >
                            View Judges
                          </NavLink>
                        </li>
                      ) : user.isAdminCooride ? (
                        <li className="nav-item mx-3">
                          <NavLink
                            className="btn btn-outline-primary"
                            to="/admin/multicity/judges"
                          >
                            View Judges
                          </NavLink>
                        </li>
                      ) : user.isSuperUser ? (
                        <li className="nav-item mx-3">
                          <NavLink
                            className="btn btn-outline-primary"
                            to="/admin/multicity/judges"
                          >
                            View Judges
                          </NavLink>
                        </li>
                      ) : (
                        <></>
                      )
                    ) : (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/multicity/judges"
                        >
                          View Judges
                        </NavLink>
                      </li>
                    )}

                    {user ? (
                      user.isSuperUser ? (
                        <li className="nav-item mx-3">
                          <NavLink
                            className="btn btn-outline-primary"
                            to="/admin/add_user"
                          >
                            Add User
                          </NavLink>
                        </li>
                      ) : (
                        <></>
                      )
                    ) : (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/add_user"
                        >
                          Add User
                        </NavLink>
                      </li>
                    )}
                  </>
                ) : (
                  <></>
                )
              ) : (
                <>
                  <li className="nav-item mx-3">
                    <NavLink
                      className="btn btn-outline-primary"
                      aria-current="page"
                      to="/judge/multicity"
                    >
                      Judge Scoring
                    </NavLink>
                  </li>
                  {user ? (
                    user.isSuperUser ? (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/competitions"
                        >
                          Admin Home
                        </NavLink>
                      </li>
                    ) : (
                      <></>
                    )
                  ) : (
                    <li className="nav-item mx-3">
                      <NavLink
                        className="btn btn-outline-primary"
                        to="/admin/competitions"
                      >
                        Admin Home
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item mx-3">
                    <NavLink
                      className="btn btn-outline-primary"
                      to="/admin/multicity"
                    >
                      Multicity Home
                    </NavLink>
                  </li>

                  {user ? (
                    user.isAdminCooride ? (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/multicity/parameters"
                        >
                          Parameter Setting
                        </NavLink>
                      </li>
                    ) : user.isSuperUser ? (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/multicity/parameters"
                        >
                          Parameter Setting
                        </NavLink>
                      </li>
                    ) : (
                      <></>
                    )
                  ) : (
                    <li className="nav-item mx-3">
                      <NavLink
                        className="btn btn-outline-primary"
                        to="/admin/multicity/parameters"
                      >
                        Parameter Setting
                      </NavLink>
                    </li>
                  )}

                  {/* ADMIN COORDIE AND ABOVE */}
                  {user ? (
                    user.isSuperUser ? (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/addcompi"
                        >
                          Add Competition
                        </NavLink>
                      </li>
                    ) : user.isAdminCooride ? (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/addcompi"
                        >
                          Add Competition
                        </NavLink>
                      </li>
                    ) : (
                      <></>
                    )
                  ) : (
                    <li className="nav-item mx-3">
                      <NavLink
                        className="btn btn-outline-primary"
                        to="/admin/addcompi"
                      >
                        Add Competition
                      </NavLink>
                    </li>
                  )}

                  {/* ONLY CGS */}
                  {user ? (
                    user.isSuperUser ? (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/multicity/addcompi"
                        >
                          Add Mul Compi
                        </NavLink>
                      </li>
                    ) : (
                      <></>
                    )
                  ) : (
                    <li className="nav-item mx-3">
                      <NavLink
                        className="btn btn-outline-primary"
                        to="/admin/multicity/addcompi"
                      >
                        Add Mul Compi
                      </NavLink>
                    </li>
                  )}

                  {user ? (
                    user.isCoordie ? (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/multicity/judges"
                        >
                          View Judges
                        </NavLink>
                      </li>
                    ) : user.isAdminCooride ? (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/multicity/judges"
                        >
                          View Judges
                        </NavLink>
                      </li>
                    ) : user.isSuperUser ? (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/multicity/judges"
                        >
                          View Judges
                        </NavLink>
                      </li>
                    ) : (
                      <></>
                    )
                  ) : (
                    <li className="nav-item mx-3">
                      <NavLink
                        className="btn btn-outline-primary"
                        to="/admin/multicity/judges"
                      >
                        View Judges
                      </NavLink>
                    </li>
                  )}

                  {user ? (
                    user.isSuperUser ? (
                      <li className="nav-item mx-3">
                        <NavLink
                          className="btn btn-outline-primary"
                          to="/admin/add_user"
                        >
                          Add User
                        </NavLink>
                      </li>
                    ) : (
                      <></>
                    )
                  ) : (
                    <li className="nav-item mx-3">
                      <NavLink
                        className="btn btn-outline-primary"
                        to="/admin/add_user"
                      >
                        Add User
                      </NavLink>
                    </li>
                  )}
                </>
              )}

              {user ? (
                user.username === "pronites" ? (
                  <li className="nav-item mx-3">
                    <NavLink
                      className="btn btn-outline-primary"
                      to="/admin/pronites"
                    >
                      Pronites
                    </NavLink>
                  </li>
                ) : (
                  <></>
                )
              ) : (
                <li className="nav-item mx-3">
                  <NavLink
                    className="btn btn-outline-primary"
                    to="/admin/pronites"
                  >
                    Pronites
                  </NavLink>
                </li>
              )}

              {localStorage.getItem("compiauthtoken") ? (
                <li className="nav-item mx-3">
                  <button
                    className="btn btn-outline-danger"
                    onClick={onLogoutClick}
                  >
                    Logout
                  </button>
                </li>
              ) : localStorage.getItem("judgeauthtoken") ? (
                <li className="nav-item mx-3">
                  <button
                    className="btn btn-outline-danger"
                    onClick={onLogoutClick}
                  >
                    Logout
                  </button>
                </li>
              ) : (
                <></>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
